import { useSelector } from 'react-redux';

import { getHaveCompletedHairProfile, getHaveOrders } from 'dux/user/selectors';
import { getIsAuthenticated, getIsAuthenticating } from 'dux/auth/selectors';

import { FIRST_QUESTION_ROUTE } from 'Apps/Consultation/constants';

import * as ctaContent from 'assets/content/consultation/cta';

const getRenderParams = ({
  haveCompletedHairProfile,
  haveOrders,
  isAuthenticated,
  productName,
}) => {
  /* XXX: Might worth implementing a light state machine  */
  if (haveOrders) {
    return {
      to: '/account/reorder',
      label: ctaContent.reorder,
      dataClick: 'order-prose',
      showShoppingCart: true,
    };
  }

  if (isAuthenticated && haveCompletedHairProfile) {
    return {
      to: '/checkout',
      label: ctaContent.abandonedCart(productName),
      dataClick: 'order-prose',
      showShoppingCart: true,
    };
  }

  if (isAuthenticated) {
    return {
      to: FIRST_QUESTION_ROUTE,
      label: ctaContent.abandonedConsultation,
      dataClick: 'consultation',
      showShoppingCart: false,
    };
  }

  return {
    to: '/consultation',
    label: ctaContent.newUser(productName),
    dataClick: 'consultation',
    showShoppingCart: false,
  };
};

function useMapSelectorsToState() {
  const haveCompletedHairProfile = useSelector(getHaveCompletedHairProfile);
  const haveOrders = useSelector(getHaveOrders);
  const isAuthenticated = useSelector(getIsAuthenticated);
  const isAuthenticating = useSelector(getIsAuthenticating);

  return { haveCompletedHairProfile, haveOrders, isAuthenticated, isAuthenticating };
}

export default function useCTA(
  { productName = null } = {},
  { useGlobalValues = useMapSelectorsToState } = {}
) {
  const {
    haveCompletedHairProfile,
    haveOrders,
    isAuthenticated,
    isAuthenticating,
  } = useGlobalValues();

  if (isAuthenticating) {
    return {
      to: '',
      label: '',
      dataClick: '',
      showShoppingCart: false,
    };
  }

  return getRenderParams({
    haveCompletedHairProfile,
    haveOrders,
    isAuthenticated,
    productName,
  });
}
